// extracted by mini-css-extract-plugin
module.exports = {"root":"u3dhe","icon":"_3NC0c","up":"_3nvS-","right":"_2lqPT"};